import React from 'react'
import { Box, Button, Link, Text } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'
import CardBodyCategory from './Card.Body.Category'
import CardBodyTitle from './Card.Body.Title'
import CardBodyExcerpt from './Card.Body.Excerpt'

const styles = {
  body: {
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`,
    padding: '0px',
    flex: 1
  },
  heading: {
    mb: 4,
    span: {
      color: `omegaDark`
    }
  },
  running: {
    color: `omegaDark`,
    fontWeight: `body`,
    width: `5/6`
  },
  stringHtml: {
    p: {
      m: 0
    }
  }
}

const CardBody = ({
  children,
  omitBody,
  isHeritage,
  isTagBlog,
  isSymposium,
  linkKey,
  ...props
}) => {
  const formatDate = date => {
    const formattedDate = new Date(date).toDateString(
      {},
      { timeZone: 'UTC', month: 'long', day: '2-digit', year: 'numeric' }
    )
    const sp = formattedDate.split(' ')
    return `${sp[1]}, ${sp[2]} ${new Date().getFullYear()}`
  }
  return (
    !omitBody && (
      <Box
        sx={{
          ...styles.body,
          variant: rv(props.variant, 'body')
        }}
        style={isHeritage || isSymposium ? { padding: '8px 0px 0px 10px' } : {}}
      >
        <CardBodyCategory {...props} />
        <CardBodyTitle
          {...props}
          isHeritage={isHeritage}
          isTagBlog={isTagBlog}
          linkKey={linkKey}
          isSymposium={isSymposium}
          callFrom={props.callFrom}
        />
        <CardBodyExcerpt
          {...props}
          isHeritage={isHeritage}
          isSymposium={isSymposium}
        />
        {props.callFrom === 'Event' ||
          (props.callFrom === 'EventPage' && (
            <>
              <Text
                variant='small'
                style={{
                  marginBottom: '10px',
                  fontFamily: `Inter, sans-serif`
                }}
              >
                {formatDate(props.eventdate)} At{'    '}
                {new Date(props.eventdate).toTimeString().slice(0, 5)}
              </Text>
            </>
          ))}
        {isHeritage && (
          <Box variant='buttons.group' sx={styles.buttons}>
            <Button
              variant='white'
              as={Link}
              href={props.button01.url}
              target='_blank'
            >
              {props.button01.name}
            </Button>
          </Box>
        )}
        {isSymposium && (
          <Box variant='buttons.group' sx={styles.buttons}>
            <Button
              variant='white'
              as={Link}
              href={props.button[0].url}
              target='_blank'
            >
              {props.button[0].name}
            </Button>
          </Box>
        )}
        {children}
      </Box>
    )
  )
}
export default CardBody
